<template>
  <div class="logincon" @click="handleClose">
    <div class="info-con login" @click="notClose">
      <div class="reg-title">注册账号</div>
      <div class="gologin">已有账号，<span @click="gologin">立即登录</span></div>
      <div class="reg-info">
        <div><input placeholder="请输入手机号" v-model="mobile"/><img src="../assets/tel.png"/></div>
        <div><input placeholder="请输入验证码" v-model="verifyCode"/><img src="../assets/vercode.png"/>
          <div class="vercode" v-if="getverification" @click="getvercode">获取验证码</div>
          <div v-if="!getverification" class="vercode grayvercode">{{count}}s后重新获取</div>
        </div>
        <div><input type="password" placeholder="请输入密码" v-model="password"/><img src="../assets/pwd.png"/></div>
        <div class="button" @click="register">注册</div>
      </div>
    </div>
  </div>
</template>
<script>

  import {http} from '../fetch/api'

  import Utils from '@/fetch/utils'
  export default {
    data() {
      return {
        activeTab: 'hgtzzrd',
        mobile: '',
        verifyCode: '',
        password: '',
        getverification: true,
        count:30,
        timer: null
      }
    },
    methods: {
      gologin() {
        this.$emit("gologin")
      },
      async submitOption(questionId, optionId) {
        var data = await http.saveAnswer(questionId, optionId)
        if (data.code == '0') {

        }
      },
      async getsurvey() {
        var data2 = await http.surveyPager("2")
        if (data2.code == '0') {
          this.institutionPaper = data2.data
          this.activeTab = 'survey'
        }
        var data1 = await http.surveyPager("1")
        if (data1.code == '0') {
          this.personalPager = data1.data
        }
      },
      async register() {
        if (!this.mobile) {
          // format.message("请输入手机号", "error")
          this.$store.state.noticeMessage="请输入手机号"
          return
        }
        if(!(/^1[3456789]\d{9}$/.test(this.mobile))) {
          this.$store.state.noticeMessage="请输入合法的手机号"
          return
        }
        if (!this.verifyCode) {
          // format.message("请输入手机号", "error")
          this.$store.state.noticeMessage="请输入验证码"
          return
        }
        if (!this.password) {
          // format.message("请输入手机号", "error")
          this.$store.state.noticeMessage="请输入密码"
          return
        }
        var from=this.$route.query.from
        var pwd=Utils.encrypt(this.password)
        var data = await http.register(this.mobile, this.verifyCode, pwd,from)
        if (data.code == '0') {
          // format.message("注册成功")
          this.$store.state.noticeMessage="注册成功"
          this.$emit("gologin")
        }
      },
      async getvercode() {
        if (!this.mobile) {
          // format.message("请输入手机号", "error")
          this.$store.state.noticeMessage="请输入手机号"
          return
        }
        if(!(/^1[3456789]\d{9}$/.test(this.mobile))) {
          this.$store.state.noticeMessage="请输入合法的手机号"
          return
        }
        var type = '1'
        var data = await http.verifyCode(this.mobile, type)
        if (data.code == '0') {
          // format.message("验证码已发送")
          this.$store.state.noticeMessage="验证码已发送"
        }

        const TIME_COUNT = 30;
        if (!this.timer) {
          // this.count = TIME_COUNT;
          var dhTime = window.localStorage.setdhTime = new Date().getTime()
          this.getverification = false;
          this.count = 30
          this.timer = setInterval(() => {
            // var setdhTime =
            this.count = TIME_COUNT - Math.round((new Date().getTime() - dhTime)/1000)
            if (this.count > 0 && this.count <= TIME_COUNT) {
              // this.count--;
            } else {
              this.getverification = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }

      },
      async changeTab() {
        if (this.activeTab == 'persurvey') {
          var data = await http.surveySubmit("1")
          if (data.code == '0') {
            // this.$emit("toperson")
            this.GLOBAL.loginstate = true
            this.$emit("closelogin")
          }
        }
        if (this.activeTab == 'survey') {
          var data = await http.surveySubmit("2")
          if (data.code == '0') {
            this.activeTab = 'persurvey'
          }
        }
      },
      handleClose() {
        this.$emit("closereg")
      },
      notClose(event) {
        event.stopPropagation()
      }
    }
  }
</script>
<style scoped>
  .logincon {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  .info-con {

    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  .eligible {
    background-image: url("../assets/hgtzzrd.png");
    width: 840px;
    height: 550px;
  }

  .text {
    font-size: 16px;
    margin: 30px 70px;
    text-align: left;
  }

  .text p {
    text-indent: 32px;
    line-height: 28px;
    letter-spacing: 1px;
  }

  .buttons div {
    display: inline-block;
    width: 240px;
    margin: 0 25px;
    color: #fff;
    border-radius: 6px;
    height: 50px;
    line-height: 50px;
  }

  .gray {
    background: #b5b5b5;
  }

  .light {
    background: #00bcbc;
  }

  .login {
    background-image: url("../assets/login.png");
    width: 840px;
    height: 550px;
  }

  .two-title {

  }

  .reg-title {
    display: inline-block;
    text-align: center;
    height: 68px;
    line-height: 68px;
    color: #fff;
    font-size: 30px;
    padding: 0 20px;
    font-family: MicrosoftYaHei-Bold;
    text-shadow: 2px 2px 20px #0ff;
    letter-spacing: 6px;
  }

  .gologin {
    margin: 80px auto 0 auto;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    text-align: right;
    width: 400px;
    color: #fff;
  }

  .gologin span {
    cursor: pointer;
    color: #0ff;
    text-decoration: underline;
  }

  .reg-info {
    width: 400px;
    margin: 0 auto;
  }

  .reg-info > div {
    position: relative;
  }

  .reg-info input {
    margin: 10px 0;
    background: #1f4661;
    width: 400px;
    height: 50px;
    border-radius: 6px;
    border: solid 1px rgba(0,255,255,.3);
    padding-left: 30px;
    box-sizing: border-box;
    outline: none;
    color: #fff;
  }

  input::input-placeholder {
    color: #c6c6c6;
  }
  input::-webkit-input-placeholder {
    color: #c6c6c6;
  }
  input::-moz-input-placeholder {
    color: #c6c6c6;
  }
  .reg-info img {
    position: absolute;
    left: 10px;
    vertical-align: middle;
    top: 25px;
    width: 14px;
  }

  .vercode {
    text-align: center;
    display: inline-block;
    width: 120px;
    border-left: solid 1px #0ff;
    position: absolute;
    right: 0;
    top: 0;
    height: 30px;
    line-height: 30px;
    color: #0ff;
    margin-top: 20px;
  }
  .grayvercode {
    color: #c6c6c6;
  }

  .button {
    width: 400px;
    height: 50px;
    background-color: #00ffff;
    border-radius: 6px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 8px;
    color: #06172f;
    margin-top: 20px;
    cursor: pointer;
  }

  .forgetpwd {
    text-align: right;
    color: #0ff;
    cursor: pointer;
  }

  .survey {
    background-image: url("../assets/jgtzzwj.png");
    width: 1020px;
    height: 735px;
  }

  .persurvey {
    background-image: url("../assets/grtzzwj.png");
    width: 1020px;
    height: 735px;
  }

  .survey p, .persurvey p {
    text-align: left;
  }

  .scroll-con {
    height: 500px;
    overflow: scroll;
  }

  /*滚动条整体样式*/
  .scroll-con::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .scroll-con::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #a4f1fc;
  }

  /*滚动条轨道*/
  .scroll-con::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: none;
  }

  .finish {
    width: 240px;
    background: #00bcbc;
    margin: 0 auto;
    color: #fff;
    height: 50px;
    line-height: 50px;
    border-radius: 6px;
  }

  .closebutton {
    position: absolute;
    color: #fff;
    right: 20px;
    top: -25px;
  }

  p .onlyline {
    display: block;
  }

  input[type="checkbox"] {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reg.vue